$(document).ready(function () {
    initCheckoutParticipant();
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
    initCheckoutParticipant();
});

function initCheckoutParticipant() {
    // Detekce: jsme na kroku s osobními údaji a poznámkou + sekce ještě neexistuje
    if (!$(".co-contact-information").length || !$("textarea[name='remark']").length) {
        return;
    }
    if ($(".participant-section").length) {
        return;
    }

    const config = getParticipantConfig();
    if (!config || !Array.isArray(config.fields) || config.fields.length === 0) {
        return;
    }

    renderParticipantSection(config);
    bindParticipantSubmitHook(config);
}

function getParticipantConfig() {
    if (typeof shopDataLayer === "undefined" || !shopDataLayer.checkout) {
        return null;
    }
    return shopDataLayer.checkout.participant || null;
}

function renderParticipantSection(config) {
    const $section = $(
        "<fieldset class='box box-sm box-bg-default co-box participant-section'>" +
            "<h4 class='participant-section__title'>" + config.title + "</h4>" +
            "<div class='participant-section__fields'></div>" +
        "</fieldset>"
    );

    const $fields = $section.find(".participant-section__fields");

    config.fields.forEach(function (field) {
        $fields.append(renderParticipantField(field));
    });

    // Vložení nad blok poznámky / newsletteru = pod doručovací adresu
    const $additional = $(".co-box-additional").first();
    if ($additional.length) {
        $section.insertBefore($additional);
    } else {
        $section.insertAfter($(".co-contact-information").last());
    }

    // Init Bootstrap tooltipů (Shoptet je inicializuje při $.ready, ale naše vložení je až poté)
    if (typeof $.fn.tooltip === "function") {
        $section.find(".show-tooltip").tooltip();
    }
}

function renderParticipantField(field) {
    const inputId = "participant-" + field.id;
    let labelInner = field.required
        ? "<span class='required-asterisk'>" + field.label + "</span>"
        : field.label;

    if (field.tooltip) {
        const tooltipId = inputId + "-description";
        labelInner += " <span class='show-tooltip question-tooltip form-group-tooltip' " +
            "aria-hidden='true' data-original-title='" + field.tooltip.replace(/'/g, "&#39;") + "'>?</span>" +
            "<span id='" + tooltipId + "' class='sr-only'>" + field.tooltip + "</span>";
    }

    const $group = $(
        "<div class='form-group js-validated-element-wrapper participant-section__group' " +
        "data-participant-field='" + field.id + "'>" +
            "<label for='" + inputId + "' class='participant-section__label'>" + labelInner + "</label>" +
        "</div>"
    );

    let $input;
    if (field.type === "textarea") {
        $input = $("<textarea></textarea>")
            .attr("id", inputId)
            .attr("rows", 3)
            .attr("placeholder", field.placeholder || "")
            .addClass("form-control participant-section__input");
    } else if (field.type === "select") {
        $input = $("<select></select>")
            .attr("id", inputId)
            .addClass("form-control participant-section__input");
        $input.append("<option value=''>" + (field.placeholder || "Vyberte") + "</option>");
        (field.options || []).forEach(function (option) {
            $input.append("<option value='" + option + "'>" + option + "</option>");
        });
    } else {
        $input = $("<input>")
            .attr("type", field.type || "text")
            .attr("id", inputId)
            .attr("placeholder", field.placeholder || "")
            .addClass("form-control participant-section__input");
    }

    $group.append($input);
    $group.append("<div class='participant-section__error'></div>");
    return $group;
}

function bindParticipantSubmitHook(config) {
    if (typeof shoptet === "undefined" || !shoptet.custom) {
        return;
    }

    shoptet.custom.postSuccessfulValidation = function (form) {
        const values = collectParticipantValues(config);

        if (!validateParticipantFields(config, values)) {
            scrollToFirstError();
            return false;
        }

        appendToRemark(config, values);
        return true;
    };
}

function collectParticipantValues(config) {
    const values = {};
    config.fields.forEach(function (field) {
        const value = $("#participant-" + field.id).val();
        values[field.id] = (value || "").toString().trim();
    });
    return values;
}

function validateParticipantFields(config, values) {
    let valid = true;
    $(".participant-section__group").removeClass("has-error")
        .find(".participant-section__error").text("");

    config.fields.forEach(function (field) {
        if (field.required && !values[field.id]) {
            valid = false;
            const $group = $(".participant-section__group[data-participant-field='" + field.id + "']");
            $group.addClass("has-error")
                .find(".participant-section__error").text("Pole je povinné");
        }
    });

    return valid;
}

function scrollToFirstError() {
    const $first = $(".participant-section__group.has-error").first();
    if (!$first.length) return;
    $("html, body").animate({
        scrollTop: $first.offset().top - 120,
    }, 300);
}

function appendToRemark(config, values) {
    const $textarea = $("textarea[name='remark']");
    if (!$textarea.length) return;

    const lines = [config.title];
    config.fields.forEach(function (field) {
        const formatted = formatFieldForNote(field, values[field.id]);
        if (formatted) {
            lines.push(formatted);
        }
    });

    const participantBlock = lines.join("\n");
    const userNote = ($textarea.val() || "").trim();
    let combined;

    if (userNote) {
        combined = userNote + "\n\n" + config.separator + "\n" + participantBlock;
    } else {
        combined = config.separator + "\n" + participantBlock;
    }

    $textarea.val(combined);

    // Odhalit poznámku (Shoptet ji defaultně schovává v js-hidden divu).
    // Trigger("change") na #add-note Shoptet listener nezpracuje, proto unhide ručně.
    const $addNote = $("#add-note");
    if ($addNote.length && !$addNote.is(":checked")) {
        $addNote.prop("checked", true);
        $("#note").removeClass("js-hidden");
    }
}

function formatFieldForNote(field, value) {
    if (!value) return "";
    let displayValue = value;
    if (field.type === "date") {
        const parts = value.split("-");
        if (parts.length === 3) {
            displayValue = parseInt(parts[2], 10) + ". " + parseInt(parts[1], 10) + ". " + parts[0];
        }
    }
    const format = field.noteFormat || "{value}";
    return format.replace("{value}", displayValue);
}
